/**
 * CMS Configuration
 * 
 * Feature flag to toggle between WordPress and Supabase CMS
 * Set to true to use Supabase CMS, false to use WordPress
 */
export const USE_SUPABASE_CMS = true;

/**
 * When USE_SUPABASE_CMS is true:
 * - Blog posts will be fetched from Supabase blog_posts table
 * - Support docs will be fetched from Supabase support_docs table
 * - AI image generation will be available in admin interface
 * 
 * When USE_SUPABASE_CMS is false:
 * - Blog posts will be fetched from WordPress REST API
 * - Support docs will be fetched from WordPress BetterDocs
 * - Content is managed in WordPress dashboard
 * 
 * Migration workflow:
 * 1. Keep false during WordPress migration
 * 2. Run migrate-wordpress-content edge function
 * 3. Test with true in staging
 * 4. Switch to true in production when ready
 */
